// Mock Data for Campaigns Feature

export const campaignsMockData = {
    overview: {
        totalRewardsPaid: 219890,
        currency: "RWF",
        liveCampaignsCount: 4,
        pendingPayouts: {
            amount: 78500,
            currency: "RWF",
            eligibleParticipantsCount: 34
        }
    },

    campaigns: [
        {
            id: "easter-cashback",
            name: "Easter Cashback",
            status: "Scheduled",
            startDate: "2025-04-14",
            endDate: "2025-04-15",
            reward: "Cashback (50%)",
            eligibleCount: 0
        },
        {
            id: "national-day-campaign",
            name: "National Day Campaign",
            status: "Live",
            startDate: "2025-05-14",
            endDate: "2025-05-21",
            reward: "5,000 RWF",
            eligibleCount: 23,
            bonus: 6000,
            participantsStats: {
                total: 29,
                eligible: 25,
                pending: 4,
                rejected: 1
            },
            checklist: [
                { id: 1, text: "Referrer account verified and KYC verified.", checked: true },
                { id: 2, text: "Referred user downloads app and completes onboarding.", checked: true },
                { id: 3, text: "Referred user completes KYC.", checked: true },
                { id: 4, text: "Referred user deposits a minimum of RWF5,000.", checked: true }
            ]
        },
        {
            id: "referral-campaign",
            name: "Referral Campaign",
            status: "Live",
            startDate: "2025-05-15",
            endDate: "2026-05-15",
            reward: "1,000 RWF",
            eligibleCount: 43
        },
        {
            id: "ramadan-mubarak",
            name: "Ramadan Mubarak",
            status: "Live",
            startDate: "2025-05-14",
            endDate: "2025-05-14",
            reward: "2,000 RWF",
            eligibleCount: 2,
            endingSoon: true
        },
        {
            id: "lent-campaign",
            name: "Lent Campaign",
            status: "Live",
            startDate: "2025-05-01",
            endDate: "2025-05-14",
            reward: "2,000 RWF",
            eligibleCount: 12
        },
        {
            id: "independence-day-campaign",
            name: "Independence Day Campaign",
            status: "Live",
            startDate: "2025-05-14",
            endDate: "2025-05-16",
            reward: "5,000 RWF",
            eligibleCount: 5
        }
    ],

    participants: [
        {
            id: "INV793437532873",
            campaignId: "national-day-campaign",
            name: "Aime Franck Karekezi",
            avatar: "https://i.pravatar.cc/150?u=aime",
            phoneNumber: "+250 789903390",
            email: "karekezifranck@gmail.com",
            gender: "Male",
            entryDate: "2025-05-14",
            paymentDate: "2025-05-15",
            status: "Paid",
            rewardAmount: 5000,
            currency: "RWF",
            conditions: [
                { id: 1, text: "Referrer account verified and KYC verified.", checked: true },
                { id: 2, text: "Referred user downloads app and completes onboarding.", checked: true },
                { id: 3, text: "Referred user completes KYC.", checked: false },
                { id: 4, text: "Referred user deposits a minimum of RWF5,000.", checked: false }
            ]
        },
        {
            id: "INV793437532874",
            campaignId: "national-day-campaign",
            name: "Arielle Mutoni",
            avatar: "https://i.pravatar.cc/150?u=arielle",
            phoneNumber: "+250 789903390",
            email: "arielle@example.com",
            gender: "Female",
            entryDate: "2025-05-15",
            paymentDate: null,
            status: "Eligible",
            rewardAmount: 5000,
            currency: "RWF",
            conditions: [
                { id: 1, text: "Referrer account verified and KYC verified.", checked: true },
                { id: 2, text: "Referred user downloads app and completes onboarding.", checked: true },
                { id: 3, text: "Referred user completes KYC.", checked: true },
                { id: 4, text: "Referred user deposits a minimum of RWF5,000.", checked: true }
            ]
        },
        {
            id: "INV793437532875",
            campaignId: "national-day-campaign",
            name: "Jean Claude Habimana",
            avatar: "https://i.pravatar.cc/150?u=jean",
            phoneNumber: "+250 788123456",
            email: "jchabimana@gmail.com",
            gender: "Male",
            entryDate: "2025-05-14",
            paymentDate: "2025-05-16",
            status: "Paid",
            rewardAmount: 5000,
            currency: "RWF",
            conditions: [
                { id: 1, text: "Referrer account verified and KYC verified.", checked: true },
                { id: 2, text: "Referred user downloads app and completes onboarding.", checked: true },
                { id: 3, text: "Referred user completes KYC.", checked: true },
                { id: 4, text: "Referred user deposits a minimum of RWF5,000.", checked: true }
            ]
        },
        {
            id: "INV793437532876",
            campaignId: "national-day-campaign",
            name: "Grace Uwimana",
            avatar: "https://i.pravatar.cc/150?u=grace",
            phoneNumber: "+250 787654321",
            email: "grace.uwimana@yahoo.com",
            gender: "Female",
            entryDate: "2025-05-15",
            paymentDate: null,
            status: "Pending",
            rewardAmount: 5000,
            currency: "RWF",
            conditions: [
                { id: 1, text: "Referrer account verified and KYC verified.", checked: true },
                { id: 2, text: "Referred user downloads app and completes onboarding.", checked: true },
                { id: 3, text: "Referred user completes KYC.", checked: false },
                { id: 4, text: "Referred user deposits a minimum of RWF5,000.", checked: false }
            ]
        },
        {
            id: "INV793437532877",
            campaignId: "national-day-campaign",
            name: "Patrick Niyonzima",
            avatar: "https://i.pravatar.cc/150?u=patrick",
            phoneNumber: "+250 786112233",
            email: "pniyonzima@inverse.rw",
            gender: "Male",
            entryDate: "2025-05-16",
            paymentDate: null,
            status: "Rejected",
            rewardAmount: 5000,
            currency: "RWF",
            conditions: [
                { id: 1, text: "Referrer account verified and KYC verified.", checked: true },
                { id: 2, text: "Referred user downloads app and completes onboarding.", checked: false },
                { id: 3, text: "Referred user completes KYC.", checked: false },
                { id: 4, text: "Referred user deposits a minimum of RWF5,000.", checked: false }
            ]
        },
        {
            id: "INV793437532878",
            campaignId: "national-day-campaign",
            name: "Diane Ishimwe",
            avatar: "https://i.pravatar.cc/150?u=diane",
            phoneNumber: "+250 785443322",
            email: "diane.ishimwe@gmail.com",
            gender: "Female",
            entryDate: "2025-05-14",
            paymentDate: "2025-05-15",
            status: "Paid",
            rewardAmount: 5000,
            currency: "RWF",
            conditions: [
                { id: 1, text: "Referrer account verified and KYC verified.", checked: true },
                { id: 2, text: "Referred user downloads app and completes onboarding.", checked: true },
                { id: 3, text: "Referred user completes KYC.", checked: true },
                { id: 4, text: "Referred user deposits a minimum of RWF5,000.", checked: true }
            ]
        },
        {
            id: "INV793437532879",
            campaignId: "national-day-campaign",
            name: "Emmanuel Mugisha",
            avatar: "https://i.pravatar.cc/150?u=emmanuel",
            phoneNumber: "+250 789556677",
            email: "emugisha@outlook.com",
            gender: "Male",
            entryDate: "2025-05-15",
            paymentDate: null,
            status: "Eligible",
            rewardAmount: 5000,
            currency: "RWF",
            conditions: [
                { id: 1, text: "Referrer account verified and KYC verified.", checked: true },
                { id: 2, text: "Referred user downloads app and completes onboarding.", checked: true },
                { id: 3, text: "Referred user completes KYC.", checked: true },
                { id: 4, text: "Referred user deposits a minimum of RWF5,000.", checked: true }
            ]
        }
    ]
};

export const mockCampaignsService = {
    getOverview: async () => {
        return new Promise(resolve => setTimeout(() => resolve(campaignsMockData.overview), 500));
    },

    getCampaigns: async (status = null) => {
        return new Promise(resolve => {
            setTimeout(() => {
                let items = campaignsMockData.campaigns;
                if (status) {
                    items = items.filter(c => c.status.toLowerCase() === status.toLowerCase());
                }
                resolve({ items, total: items.length });
            }, 500);
        });
    },

    getCampaign: async (id) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const campaign = campaignsMockData.campaigns.find(c => c.id === id);
                if (campaign) resolve(campaign);
                else reject(new Error("Campaign not found"));
            }, 500);
        });
    },

    getParticipants: async (campaignId) => {
        return new Promise(resolve => {
            setTimeout(() => {
                const items = campaignsMockData.participants.filter(p => p.campaignId === campaignId);
                resolve({ items, total: items.length });
            }, 500);
        });
    },

    getParticipantDetails: async (campaignId, participantId) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const participant = campaignsMockData.participants.find(p => p.id === participantId && p.campaignId === campaignId);
                if (participant) resolve(participant);
                else reject(new Error("Participant not found"));
            }, 500);
        });
    }
};
